import React, { useEffect, useState } from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import { FiLogOut, FiUser } from 'react-icons/fi';
import { MdReviews, MdWork } from "react-icons/md";
import { MdSupervisorAccount, MdWorkspaces } from 'react-icons/md';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { apiGet, apiPut } from '../API/Api_Url';
import UserAllConstructionRequirement from './Requirement/User/UserAllConstructionRequirement';
import UserAllPendingConstructionRequirement from './Requirement/User/UserAllPendingConstructionRequirement';
import UpdateProfile from './Profile/UpdateProfile';
import AllMyServiceRequirement from './ServiceRequirement/AllMyServiceRequirement';
import MyPendingServiceRequirements from './ServiceRequirement/MyPendingServiceRequirements';
import UserAllInReviewConstructionRequirement from './Requirement/User/UserAllInReviewConstructionRequirement';
import UserAllPriceProvidedConstructionRequirement from './Requirement/User/UserAllPriceProvidedConstructionRequirement';
import UserAllApprovedConstructionRequirement from './Requirement/User/UserAllApprovedConstructionRequirement';
import MyApprovedServiceRequirements from './ServiceRequirement/MyApprovedServiceRequirements';
import MyInProgressServiceRequirements from './ServiceRequirement/MyInProgressServiceRequirements';
import MyCompletedServiceRequirements from './ServiceRequirement/MyCompletedServiceRequirements';
import MyCancelledServiceRequirements from './ServiceRequirement/MyCancelledServiceRequirements';
import { Briefcase, CheckCircle, CheckCircle2, Clock, DollarSign, Edit3, Eye, FileText, LogOut, PlayCircle, Timer, User, XCircle } from 'lucide-react';
import { EyeOff, Star, Trophy, Coins } from 'lucide-react';
import UserAllAgreementPendingConstructionRequirement from './Requirement/User/UserAllAgreementPendingConstructionRequirement';
import UserAllInConstructionRequirement from './Requirement/User/UserAllInConstructionRequirement';
import { GrOrderedList } from 'react-icons/gr';
import UserAllCompletedConstructionRequirement from './Requirement/User/UserAllCompletedConstructionRequirement';
import UserProfile from './Requirement/User/UserProfile';
import ContractorProfile from './Contractor/Profile/ContractorProfile';
import ContractorUpdateProfile from './Contractor/Profile/ContractorUpdateProfile';
import FreelancerProfile from './Freelancer/Profile/FreelancerProfile';
import FreelancerProfileUpdate from './Freelancer/Profile/FreelancerProfileUpdate';
import UserAllFreelancerJobPost from './Requirement/UserFreelancer/UserAllFreelancerJobPost';
import UserAllPendingFreelancerJobPost from './Requirement/UserFreelancer/UserAllPendingFreelancerJobPost';
import UserAllFreelancerSelectedJobPost from './Requirement/UserFreelancer/UserAllFreelancerSelectedJobPost';
import UserAllFreelancerAgreementPendingJobPost from './Requirement/UserFreelancer/UserAllFreelancerAgreementPendingJobPost';
import UserAllFreelancerInConstructionJobPost from './Requirement/UserFreelancer/UserAllFreelancerInConstructionJobPost';
import UserAllFreelancerCompletedJobPost from './Requirement/UserFreelancer/UserAllFreelancerCompletedJobPost';
import UserAllMaterialRequest from './Requirement/UserMaterialSupplier/UserAllMaterialRequest';
import UserAllPendingMaterialRequest from './Requirement/UserMaterialSupplier/UserAllPendingMaterialRequest';
import UserAllSupplierSelectedMaterialRequest from './Requirement/UserMaterialSupplier/UserAllSupplierSelectedMaterialRequest';
import UserAllSupplierConfirmedMaterialRequest from './Requirement/UserMaterialSupplier/UserAllSupplierConfirmedMaterialRequest';
import UserAllInTransitMaterialRequest from './Requirement/UserMaterialSupplier/UserAllInTransitMaterialRequest';
import UserAllDeliveredMaterialRequest from './Requirement/UserMaterialSupplier/UserAllDeliveredMaterialRequest';
import UserAllCompletedMaterialRequest from './Requirement/UserMaterialSupplier/UserAllCompletedMaterialRequest';
import UserAllRejectedAndReturnMaterialRequest from './Requirement/UserMaterialSupplier/UserAllRejectedAndReturnMaterialRequest';
import UserAllLabourJobPost from './Requirement/UserLabour/UserAllLabourJobPost';
import UserAllPendingLabourJobPost from './Requirement/UserLabour/UserAllPendingLabourJobPost';
import UserAllInProgressLabourJobPost from './Requirement/UserLabour/UserAllInProgressLabourJobPost';
import UserAllCompletedLabourJobPost from './Requirement/UserLabour/UserAllCompletedLabourJobPost';
import UserAllCancelledLabourJobPost from './Requirement/UserLabour/UserAllCancelledLabourJobPost';
import SupplierProfile from './Supplier/Profile/SupplierProfile';
import SupplierProfileUpdate from './Supplier/Profile/SupplierProfileUpdate';
import AllPendingMaterialRequest from './Supplier/MaterialRequest/AllPendingMaterialRequest';
import AllAssignedMaterialRequests from './Supplier/MaterialRequest/AllAssignedMaterialRequests';
import LabourProfile from './Labour/Profile/LabourProfile';
import UpdateLabourProfile from './Labour/Profile/UpdateLabourProfile';
import AllPendingJobRequirement from './Labour/AllRequest/AllPendingJobRequirement';
import AllAssignedJobRequirement from './Labour/AllRequest/AllAssignedJobRequirement';
import AllTransactions from './Labour/AllRequest/AllTransactions';
import AllPendingJobPost from './Freelancer/AllRequirement/AllPendingJobPost';
import AllAssignedJobPost from './Freelancer/AllRequirement/AllAssignedJobPost';
import AllMyReviews from './Freelancer/AllRequirement/AllMyReviews';
import FreelancerAllMaterialRequest from './Freelancer/MaterialSupply/FreelancerAllMaterialRequest';
import FreelancerAllPendingMaterialRequest from './Freelancer/MaterialSupply/FreelancerAllPendingMaterialRequest';
import FreelancerAllSupplierSelectedMaterialRequest from './Freelancer/MaterialSupply/FreelancerAllSupplierSelectedMaterialRequest';
import FreelancerAllSupplierConfirmedMaterialRequest from './Freelancer/MaterialSupply/FreelancerAllSupplierConfirmedMaterialRequest';
import FreelancerAllInTransitMaterialRequest from './Freelancer/MaterialSupply/FreelancerAllInTransitMaterialRequest';
import FreelancerAllDeliveredMaterialRequest from './Freelancer/MaterialSupply/FreelancerAllDeliveredMaterialRequest';
import FreelancerAllCompletedMaterialRequest from './Freelancer/MaterialSupply/FreelancerAllCompletedMaterialRequest';
import FreelancerAllRejectedAndReturnMaterialRequest from './Freelancer/MaterialSupply/FreelancerAllRejectedAndReturnMaterialRequest';
import FreelancerAllLabourJobPost from './Freelancer/HireLabour/FreelancerAllLabourJobPost';
import FreelancerAllPendingLabourJobPost from './Freelancer/HireLabour/FreelancerAllPendingLabourJobPost';
import FreelancerAllInProgressLabourJobPost from './Freelancer/HireLabour/FreelancerAllInProgressLabourJobPost';
import FreelancerAllCompletedLabourJobPost from './Freelancer/HireLabour/FreelancerAllCompletedLabourJobPost';
import FreelancerAllCancelledLabourJobPost from './Freelancer/HireLabour/FreelancerAllCancelledLabourJobPost';
import AdminAssignConstructionRequirement from './Contractor/ConstructionRequirement/AdminAssignConstructionRequirement';
import AllAssignedConstructionRequirements from './Contractor/ConstructionRequirement/AllAssignedConstructionRequirements';
import AllCompletedConstructionRequirements from './Contractor/ConstructionRequirement/AllCompletedConstructionRequirements';
import ContractorAllFreelancerJobPost from './Contractor/FreelancerJobPost/ContractorAllFreelancerJobPost';
import ContractorAllPendingFreelancerJobPost from './Contractor/FreelancerJobPost/ContractorAllPendingFreelancerJobPost';
import ContractorAllFreelancerSelectedJobPost from './Contractor/FreelancerJobPost/ContractorAllFreelancerSelectedJobPost';
import ContractorAllFreelancerAgreementPendingJobPost from './Contractor/FreelancerJobPost/ContractorAllFreelancerAgreementPendingJobPost';
import ContractorAllFreelancerInConstructionJobPost from './Contractor/FreelancerJobPost/ContractorAllFreelancerInConstructionJobPost';
import ContractorAllFreelancerCompletedJobPost from './Contractor/FreelancerJobPost/ContractorAllFreelancerCompletedJobPost';
import ContractorAllLabourJobPost from './Contractor/Labour/ContractorAllLabourJobPost';
import ContractorAllPendingLabourJobPost from './Contractor/Labour/ContractorAllPendingLabourJobPost';
import ContractorAllInProgressLabourJobPost from './Contractor/Labour/ContractorAllInProgressLabourJobPost';
import ContractorAllCompletedLabourJobPost from './Contractor/Labour/ContractorAllCompletedLabourJobPost';
import ContractorAllCancelledLabourJobPost from './Contractor/Labour/ContractorAllCancelledLabourJobPost';


function Profile() {
    const navigate = useNavigate()

    const location = useLocation();

    useEffect(() => {
        if (location?.state?.SelectedTab) {
            setSelectedTab(location.state.SelectedTab);
        }
        if (location?.state?.RequirementState) {
            setRequirementState(location.state.RequirementState);
        }
    }, [location.state]);

    const [IsUploading, setIsUploading] = useState(false);
    const [WordRequirementState, setWordRequirementState] = useState('All');
    const [RequirementState, setRequirementState] = useState('All');
    const [SelectedTab, setSelectedTab] = useState('Profile');
    const ChangeTab = (text) => {
        setRequirementState('All')
        setSelectedTab(text)
    }

    const [Name, setName] = useState('');
    const [Email, setEmail] = useState('');
    const [Number, setNumber] = useState();


    const handleLogout = () => {
        localStorage.removeItem('user');
        localStorage.removeItem('userToken');
        localStorage.removeItem('UserType');
        toast.success('Logout Successful');
        navigate('/');
        setTimeout(() => {
            window.location.reload();
        }, 3000);
    };

    const [IsUser, setIsUser] = useState(false);
    const [Iscontractor, setIscontractor] = useState(false);
    const [Issupplier, setIssupplier] = useState(false);
    const [IsfreelanceEngineer, setIsfreelanceEngineer] = useState(false);
    const [Islabour, setlabour] = useState(false);


    useEffect(() => {
        const userType = localStorage.getItem("UserType");
        if (userType === "User") {
            setIsUser(true);
        }
        if (userType === "contractor") {
            setIscontractor(true);
        }
        if (userType === "supplier") {
            setIssupplier(true);
        }
        if (userType === "freelanceEngineer") {
            setIsfreelanceEngineer(true);
        }
        if (userType === "labour") {
            setlabour(true);
        }
    }, []);



    const [IsLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem("userToken");
        if (token) {
            setIsLoggedIn(true);
        } else {
            setIsLoggedIn(false);
        }
    }, []);

    const [Userdata, setUserdata] = useState(null);

    const GetUserProfile = async () => {
        try {
            setIsUploading(true);
            const response = await apiGet('api/user/self');
            setUserdata(response.data);
            const data = response.data
            setName(data?.name)
            setEmail(data?.email)
            setNumber(data?.phone)
            setIsUploading(false);
        } catch (error) {
            setIsUploading(false);
            console.error('Error fetching data:', error);
        }
    }

    useEffect(() => {
        if (IsLoggedIn && IsUser) {
            GetUserProfile();
        }
    }, [IsLoggedIn, IsUser]);




    const [ProUserdata, setProUserdata] = useState([]);

    const GetProUserdata = async () => {
        try {
            setIsUploading(true);
            let endpoint = '';

            if (Iscontractor) endpoint = 'api/contractor/self';
            else if (IsfreelanceEngineer) endpoint = 'api/freelance-engineer/self';
            else if (Issupplier) endpoint = 'api/material-supplier/self';
            else if (Islabour) endpoint = 'api/labour/self';

            if (!endpoint) return;

            const response = await apiGet(endpoint);
            setProUserdata(response?.data);
            setIsUploading(false);
        } catch (error) {
            setIsUploading(false);
            console.error('Error fetching ProUserdatas:', error);
        }
    };

    useEffect(() => {
        if (IsLoggedIn) {
            GetProUserdata();
        }
    }, [IsLoggedIn, IsUser, Iscontractor, Issupplier, IsfreelanceEngineer, Islabour]);



    return (
        <>
            <Navbar />
            {
                IsUser &&
                <div className="min-h-screen bg-gray-100 flex flex-col md:flex-row p-4 md:p-6">
                    <aside className="w-full md:w-64 bg-white shadow-xl rounded-xl p-4 md:p-6 md:mr-6 mb-6 md:mb-0 top-[15%] mt-[7%] h-fit">
                        <ul className="space-y-2 text-sm font-medium">
                            {[
                                { key: "Profile", label: "Profile", icon: <User /> },
                                { key: "My All Requirement", label: "My All Requirement", icon: <FileText /> },
                                { key: "All My Service Requirement", label: "All My Service Requirement", icon: <Briefcase /> },
                                { key: "Payment Tracking", label: "Payment Tracking", icon: <DollarSign /> },
                                { key: "Hire Supervisor", label: "Hire Freelancer Engineer", icon: <MdSupervisorAccount /> },
                                { key: "Order Material", label: "Order Material", icon: <GrOrderedList /> },
                                { key: "Hire Labour", label: "Hire Labour", icon: <MdWork /> },
                                { key: "Update Profile", label: "Update Profile", icon: <Edit3 /> },
                            ].map((tab) => (
                                <li
                                    key={tab.key}
                                    onClick={() => ChangeTab(tab.key)}
                                    className={`px-6 py-3 rounded-lg flex items-center gap-2 cursor-pointer transition-colors ${SelectedTab === tab.key
                                        ? "bg-gradient-to-r from-blue-500 to-red-500 text-white hover:opacity-90"
                                        : "text-gray-600 hover:bg-gray-100"
                                        }`}
                                >
                                    {tab.icon} {tab.label}
                                </li>

                            ))}
                            <li
                                onClick={handleLogout}
                                className="px-6 py-3 rounded-lg flex items-center gap-2 cursor-pointer text-red-600 hover:bg-red-100 transition-colors"
                            >
                                <LogOut size={20} /> Log Out
                            </li>
                        </ul>
                    </aside>

                    <main className="flex-1 space-y-6 pt-[7%]">
                        {SelectedTab === "Profile" && <UserProfile Userdata={Userdata} ChangeTab={ChangeTab} />}
                        {SelectedTab === "My All Requirement" && RequirementState === 'All' && <UserAllConstructionRequirement RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "My All Requirement" && RequirementState === 'pending' && <UserAllPendingConstructionRequirement RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "My All Requirement" && RequirementState === 'in_review' && <UserAllInReviewConstructionRequirement RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "My All Requirement" && RequirementState === 'price_provided' && <UserAllPriceProvidedConstructionRequirement RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "My All Requirement" && RequirementState === 'approved' && <UserAllApprovedConstructionRequirement RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "My All Requirement" && RequirementState === 'AgreementPending' && <UserAllAgreementPendingConstructionRequirement RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "My All Requirement" && RequirementState === 'InConstruction' && <UserAllInConstructionRequirement RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "My All Requirement" && RequirementState === 'Completed' && <UserAllCompletedConstructionRequirement RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "All My Service Requirement" && WordRequirementState == 'All' && <AllMyServiceRequirement WordRequirementState={WordRequirementState} setWordRequirementState={setWordRequirementState} />}
                        {SelectedTab === "All My Service Requirement" && WordRequirementState == 'Pending' && <MyPendingServiceRequirements WordRequirementState={WordRequirementState} setWordRequirementState={setWordRequirementState} />}
                        {SelectedTab === "All My Service Requirement" && WordRequirementState == 'Approved' && <MyApprovedServiceRequirements WordRequirementState={WordRequirementState} setWordRequirementState={setWordRequirementState} />}
                        {SelectedTab === "All My Service Requirement" && WordRequirementState == 'InProgress' && <MyInProgressServiceRequirements WordRequirementState={WordRequirementState} setWordRequirementState={setWordRequirementState} />}
                        {SelectedTab === "All My Service Requirement" && WordRequirementState == 'Completed' && <MyCompletedServiceRequirements WordRequirementState={WordRequirementState} setWordRequirementState={setWordRequirementState} />}
                        {SelectedTab === "All My Service Requirement" && WordRequirementState == 'Cancelled' && <MyCancelledServiceRequirements WordRequirementState={WordRequirementState} setWordRequirementState={setWordRequirementState} />}
                        {SelectedTab === "Hire Supervisor" && RequirementState === 'All' && <UserAllFreelancerJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Hire Supervisor" && RequirementState === 'pending' && <UserAllPendingFreelancerJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Hire Supervisor" && RequirementState === 'Selected' && <UserAllFreelancerSelectedJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Hire Supervisor" && RequirementState === 'AgreementPending' && <UserAllFreelancerAgreementPendingJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Hire Supervisor" && RequirementState === 'InConstruction' && <UserAllFreelancerInConstructionJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Hire Supervisor" && RequirementState === 'Completed' && <UserAllFreelancerCompletedJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Order Material" && RequirementState === 'All' && <UserAllMaterialRequest RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Order Material" && RequirementState === 'pending' && <UserAllPendingMaterialRequest RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Order Material" && RequirementState === 'SupplierSelected' && <UserAllSupplierSelectedMaterialRequest RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Order Material" && RequirementState === 'Confirmed' && <UserAllSupplierConfirmedMaterialRequest RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Order Material" && RequirementState === 'InTransit' && <UserAllInTransitMaterialRequest RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Order Material" && RequirementState === 'Delivered' && <UserAllDeliveredMaterialRequest RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Order Material" && RequirementState === 'Completed' && <UserAllCompletedMaterialRequest RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Order Material" && RequirementState === 'RejectedAndReturn' && <UserAllRejectedAndReturnMaterialRequest RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Hire Labour" && RequirementState === 'All' && <UserAllLabourJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Hire Labour" && RequirementState === 'pending' && <UserAllPendingLabourJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Hire Labour" && RequirementState === 'InProgress' && <UserAllInProgressLabourJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Hire Labour" && RequirementState === 'Completed' && <UserAllCompletedLabourJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Hire Labour" && RequirementState === 'Cancelled' && <UserAllCancelledLabourJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Update Profile" && <UpdateProfile Name={Name} Email={Email} Number={Number} setName={setName} setEmail={setEmail} setNumber={setNumber} GetUserProfile={GetUserProfile} />}
                    </main>
                </div>
            }
            {Iscontractor &&
                <div className="min-h-screen bg-gray-100 flex flex-col md:flex-row p-4 md:p-6">
                    <aside className="w-full md:w-64 bg-white shadow-xl rounded-xl p-4 md:p-6 md:mr-6 mb-6 md:mb-0 top-[15%] mt-[7%] h-fit">
                        <ul className="space-y-2 text-sm font-medium">
                            {[
                                { key: "Profile", label: "Profile", icon: <User /> },
                                { key: "Admin Assign Requirement", label: "Admin Assign Requirement", icon: <FileText /> },
                                { key: "All Assigned Requirements", label: "All Assigned Requirements", icon: <FileText /> },
                                { key: "All Completed Requirements", label: "All Completed Requirements", icon: <FileText /> },
                                { key: "Hire Supervisor", label: "Hire Freelancer Engineer", icon: <MdSupervisorAccount /> },
                                { key: "Hire Labour", label: "Hire Labour", icon: <MdWork /> },
                                { key: "Update Profile", label: "Update Profile", icon: <Edit3 /> },
                            ].map((tab) => (
                                <li
                                    key={tab.key}
                                    onClick={() => ChangeTab(tab.key)}
                                    className={`px-6 py-3 rounded-lg flex items-center gap-2 cursor-pointer transition-colors ${SelectedTab === tab.key
                                        ? "bg-gradient-to-r from-blue-500 to-red-500 text-white hover:opacity-90"
                                        : "text-gray-600 hover:bg-gray-100"
                                        }`}
                                >
                                    {tab.icon} {tab.label}
                                </li>

                            ))}
                            <li
                                onClick={handleLogout}
                                className="px-6 py-3 rounded-lg flex items-center gap-2 cursor-pointer text-red-600 hover:bg-red-100 transition-colors"
                            >
                                <LogOut size={20} /> Log Out
                            </li>
                        </ul>
                    </aside>

                    <main className="flex-1 space-y-6 pt-[7%]">
                        {SelectedTab === "Profile" && <ContractorProfile ProUserdata={ProUserdata} ChangeTab={ChangeTab} />}
                        {SelectedTab === "Admin Assign Requirement" && <AdminAssignConstructionRequirement />}
                        {SelectedTab === "All Assigned Requirements" && <AllAssignedConstructionRequirements />}
                        {SelectedTab === "All Completed Requirements" && <AllCompletedConstructionRequirements />}
                        {SelectedTab === "My All Requirement" && RequirementState === 'All' && <UserAllConstructionRequirement RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Update Profile" && <ContractorUpdateProfile ProUserdata={ProUserdata} ChangeTab={ChangeTab} GetUserProfile={GetProUserdata} />}
                        {SelectedTab === "Hire Supervisor" && RequirementState === 'All' && <ContractorAllFreelancerJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Hire Supervisor" && RequirementState === 'pending' && <ContractorAllPendingFreelancerJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Hire Supervisor" && RequirementState === 'Selected' && <ContractorAllFreelancerSelectedJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Hire Supervisor" && RequirementState === 'AgreementPending' && <ContractorAllFreelancerAgreementPendingJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Hire Supervisor" && RequirementState === 'InConstruction' && <ContractorAllFreelancerInConstructionJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Hire Supervisor" && RequirementState === 'Completed' && <ContractorAllFreelancerCompletedJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Hire Labour" && RequirementState === 'All' && <ContractorAllLabourJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Hire Labour" && RequirementState === 'pending' && <ContractorAllPendingLabourJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Hire Labour" && RequirementState === 'InProgress' && <ContractorAllInProgressLabourJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Hire Labour" && RequirementState === 'Completed' && <ContractorAllCompletedLabourJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Hire Labour" && RequirementState === 'Cancelled' && <ContractorAllCancelledLabourJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />}

                    </main>
                </div>
            }
            {IsfreelanceEngineer &&
                <div className="min-h-screen bg-gray-100 flex flex-col md:flex-row p-4 md:p-6">
                    <aside className="w-full md:w-64 bg-white shadow-xl rounded-xl p-4 md:p-6 md:mr-6 mb-6 md:mb-0 top-[15%] mt-[7%] h-fit">
                        <ul className="space-y-2 text-sm font-medium">
                            {[
                                { key: "Profile", label: "Profile", icon: <User /> },
                                { key: "All Pending Job Post", label: "All Pending Job Post", icon: <FileText /> },
                                { key: "All Assigned Job Post", label: "All Assigned Job Post", icon: <FileText /> },
                                // { key: "Order Material", label: "Order Material", icon: <GrOrderedList /> },
                                // { key: "Hire Labour", label: "Hire Labour", icon: <MdWork /> },
                                { key: "All My Reviews", label: "All My Reviews", icon: <MdReviews /> },
                                { key: "Update Profile", label: "Update Profile", icon: <Edit3 /> },
                            ].map((tab) => (
                                <li
                                    key={tab.key}
                                    onClick={() => ChangeTab(tab.key)}
                                    className={`px-6 py-3 rounded-lg flex items-center gap-2 cursor-pointer transition-colors ${SelectedTab === tab.key
                                        ? "bg-gradient-to-r from-blue-500 to-red-500 text-white hover:opacity-90"
                                        : "text-gray-600 hover:bg-gray-100"
                                        }`}
                                >
                                    {tab.icon} {tab.label}
                                </li>

                            ))}
                            <li
                                onClick={handleLogout}
                                className="px-6 py-3 rounded-lg flex items-center gap-2 cursor-pointer text-red-600 hover:bg-red-100 transition-colors"
                            >
                                <LogOut size={20} /> Log Out
                            </li>
                        </ul>
                    </aside>

                    <main className="flex-1 space-y-6 pt-[7%]">
                        {SelectedTab === "Profile" && <FreelancerProfile ProUserdata={ProUserdata} ChangeTab={ChangeTab} />}
                        {SelectedTab === "All Pending Job Post" && <AllPendingJobPost ProUserdata={ProUserdata} ChangeTab={ChangeTab} />}
                        {SelectedTab === "All Assigned Job Post" && <AllAssignedJobPost ProUserdata={ProUserdata} ChangeTab={ChangeTab} />}
                        {/* {SelectedTab === "Order Material" && RequirementState === 'All' && <FreelancerAllMaterialRequest RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Order Material" && RequirementState === 'pending' && <FreelancerAllPendingMaterialRequest RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Order Material" && RequirementState === 'SupplierSelected' && <FreelancerAllSupplierSelectedMaterialRequest RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Order Material" && RequirementState === 'Confirmed' && <FreelancerAllSupplierConfirmedMaterialRequest RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Order Material" && RequirementState === 'InTransit' && <FreelancerAllInTransitMaterialRequest RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Order Material" && RequirementState === 'Delivered' && <FreelancerAllDeliveredMaterialRequest RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Order Material" && RequirementState === 'Completed' && <FreelancerAllCompletedMaterialRequest RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Order Material" && RequirementState === 'RejectedAndReturn' && <FreelancerAllRejectedAndReturnMaterialRequest RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Hire Labour" && RequirementState === 'All' && <FreelancerAllLabourJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Hire Labour" && RequirementState === 'pending' && <FreelancerAllPendingLabourJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Hire Labour" && RequirementState === 'InProgress' && <FreelancerAllInProgressLabourJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Hire Labour" && RequirementState === 'Completed' && <FreelancerAllCompletedLabourJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />}
                        {SelectedTab === "Hire Labour" && RequirementState === 'Cancelled' && <FreelancerAllCancelledLabourJobPost RequirementState={RequirementState} setRequirementState={setRequirementState} />} */}
                        {SelectedTab === "All My Reviews" && <AllMyReviews />}
                        {SelectedTab === "Update Profile" && <FreelancerProfileUpdate ProUserdata={ProUserdata} ChangeTab={ChangeTab} GetUserProfile={GetProUserdata} />}
                    </main>
                </div>
            }
            {Issupplier &&
                <div className="min-h-screen bg-gray-100 flex flex-col md:flex-row p-4 md:p-6">
                    <aside className="w-full md:w-64 bg-white shadow-xl rounded-xl p-4 md:p-6 md:mr-6 mb-6 md:mb-0 top-[15%] mt-[7%] h-fit">
                        <ul className="space-y-2 text-sm font-medium">
                            {[
                                { key: "Profile", label: "Profile", icon: <User /> },
                                { key: "All Pending Material Request", label: "All Pending Material Request", icon: <Briefcase /> },
                                { key: "All Assigned Material Request", label: "All Assigned Material Request", icon: <FileText /> },
                                { key: "Update Profile", label: "Update Profile", icon: <Edit3 /> },
                            ].map((tab) => (
                                <li
                                    key={tab.key}
                                    onClick={() => ChangeTab(tab.key)}
                                    className={`px-6 py-3 rounded-lg flex items-center gap-2 cursor-pointer transition-colors ${SelectedTab === tab.key
                                        ? "bg-gradient-to-r from-blue-500 to-red-500 text-white hover:opacity-90"
                                        : "text-gray-600 hover:bg-gray-100"
                                        }`}
                                >
                                    {tab.icon} {tab.label}
                                </li>

                            ))}
                            <li
                                onClick={handleLogout}
                                className="px-6 py-3 rounded-lg flex items-center gap-2 cursor-pointer text-red-600 hover:bg-red-100 transition-colors"
                            >
                                <LogOut size={20} /> Log Out
                            </li>
                        </ul>
                    </aside>

                    <main className="flex-1 space-y-6 pt-[7%]">
                        {SelectedTab === "Profile" && <SupplierProfile ProUserdata={ProUserdata} ChangeTab={ChangeTab} />}
                        {SelectedTab === "All Pending Material Request" && <AllPendingMaterialRequest ProUserdata={ProUserdata} />}
                        {SelectedTab === "All Assigned Material Request" && <AllAssignedMaterialRequests />}
                        {SelectedTab === "Update Profile" && <SupplierProfileUpdate ProUserdata={ProUserdata} ChangeTab={ChangeTab} GetUserProfile={GetProUserdata} />}
                    </main>
                </div>
            }
            {Islabour &&
                <div className="min-h-screen bg-gray-100 flex flex-col md:flex-row p-4 md:p-6">
                    <aside className="w-full md:w-64 bg-white shadow-xl rounded-xl p-4 md:p-6 md:mr-6 mb-6 md:mb-0 top-[15%] mt-[7%] h-fit">
                        <ul className="space-y-2 text-sm font-medium">
                            {[
                                { key: "Profile", label: "Profile", icon: <User /> },
                                { key: "All Pending Job Requirement", label: "All Pending Job Requirement", icon: <FileText /> },
                                { key: "All Assigned Job Requirement", label: "All Assigned Job Requirement", icon: <FileText /> },
                                { key: "All Transactions", label: "All Transactions", icon: <FileText /> },
                                { key: "Update Profile", label: "Update Profile", icon: <Edit3 /> },
                            ].map((tab) => (
                                <li
                                    key={tab.key}
                                    onClick={() => ChangeTab(tab.key)}
                                    className={`px-6 py-3 rounded-lg flex items-center gap-2 cursor-pointer transition-colors ${SelectedTab === tab.key
                                        ? "bg-gradient-to-r from-blue-500 to-red-500 text-white hover:opacity-90"
                                        : "text-gray-600 hover:bg-gray-100"
                                        }`}
                                >
                                    {tab.icon} {tab.label}
                                </li>

                            ))}
                            <li
                                onClick={handleLogout}
                                className="px-6 py-3 rounded-lg flex items-center gap-2 cursor-pointer text-red-600 hover:bg-red-100 transition-colors"
                            >
                                <LogOut size={20} /> Log Out
                            </li>
                        </ul>
                    </aside>

                    <main className="flex-1 space-y-6 pt-[7%]">
                        {SelectedTab === "Profile" && <LabourProfile ProUserdata={ProUserdata} ChangeTab={ChangeTab} />}
                        {SelectedTab === "All Pending Job Requirement" && <AllPendingJobRequirement ProUserdata={ProUserdata} />}
                        {SelectedTab === "All Assigned Job Requirement" && <AllAssignedJobRequirement ProUserdata={ProUserdata} />}
                        {SelectedTab === "All Transactions" && <AllTransactions />}
                        {SelectedTab === "Update Profile" && <UpdateLabourProfile ProUserdata={ProUserdata} ChangeTab={ChangeTab} GetUserProfile={GetProUserdata} />}
                    </main>
                </div>
            }

            <Footer />
        </>
    )
}

export default Profile